import { X } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Button } from '@/ui-components/Button'
import { Dialog, DialogActions, DialogTitle } from '@/ui-components/Dialog'

type SignOffConfirmationModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

const SignOffConfirmationModal = ({ isOpen, onClose, onConfirm }: SignOffConfirmationModalProps) => {
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(false)
  }, [isOpen])

  const handleConfirm = () => {
    setIsLoading(true)
    onConfirm()
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span>Ready to sign-off this charter?</span>
          <Button
            plain
            onClick={onClose}
            aria-label="Close"
          >
            <X data-slot="icon" />
          </Button>
        </div>
      </DialogTitle>
      <div className="text-sm mt-2 text-pretty">
        Once you sign-off this charter:
        <ul className="px-4 list-disc list-outside mt-1 mb-4 text-gray-500 dark:text-gray-400">
          <li>Spenders will no longer be able to log new expenses.</li>
          <li>A gratuity expense will be automatically added based on the amount you specify.</li>
        </ul>
        Are you sure you want to proceed with this sign-off?
      </div>
      <DialogActions>
        <Button
          outline
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isLoading}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isLoading}
          onClick={handleConfirm}
        >
          {isLoading ? 'Signing off...' : 'Sign off'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SignOffConfirmationModal
